import React from 'react';
import Button from './button';
import style from './boxContentCreator.module.css'

const BoxContentCreator = (props) => {
    return(
        <div className={style.container}>
            <div>
                <h4>{props.heading}</h4>
                <p>{props.text}</p>
                <Button type={'pink'} 
                title={props.buttonText}
                link={props.link}>
                </Button>
            </div>
        </div>
    )
}
export default BoxContentCreator;